import '../styles/index.scss';
import './styles/index.scss';
import '../graphql/contentful';
import React from 'react';
import { isHeaderFooterEnabled, mergeClassNames } from '../utils';
import FloatingChatBubble from '../components/generic/FloatingChatBubble';
import QuoteView from '../components/QuoteView';
import HeaderWebex from './Header-webex';
import FooterWebex from './Footer-webex';
import styles from './WebexLayout.module.scss';

export default function WebexLayout(props) {
  const { children } = props;

  return (
    <div className={styles.layout}>
      <QuoteView />

      <div className={styles.header}>{isHeaderFooterEnabled && <HeaderWebex />}</div>

      <div className={styles.container}>
        <article className={mergeClassNames(styles.pageContent, 'pwp')}>{children}</article>
        {isHeaderFooterEnabled && (
          <footer className={styles.footer}>
            <FooterWebex />
          </footer>
        )}
      </div>
      <FloatingChatBubble />
      <div id="modal-root" className="pwp" />
    </div>
  );
}
